import { render } from "./Dashboard.vue?vue&type=template&id=6742487e"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=6742487e&lang=css"
script.render = render

export default script